import React from 'react';
import {connect} from 'react-redux';
import cn from "classnames";

import styles from '../../lib/global.css';
import Page from '../../components/page/page';
import Footer from '../../components/footer/footer.jsx';
import TeacherNavBar from "../../components/teacher-nav-bar/teacher-nav-bar";

import {getCourses} from '../../api/course';

import {setCourses} from "../../reducers/teach";
import bindAll from "lodash.bindall";
import LibraryComponent from "../../../components/library/library-no-modal";


/**
 * 班级列表页
 */
class  TeacherCoursesPage extends React.PureComponent{
    constructor(props) {
        super(props);
        bindAll(this, [
            'getCourses',
            'handleItemSelect'
        ]);
    }

    componentDidMount() {
        this.getCourses();
    }

    getCourses() {
        getCourses({}, {quiet: this.props.courses.data.length}).then(res => {
            this.props.setCourses(res);
        });
    }

    handleItemSelect(item) {
        this.props.history.push("teacher-course?id=" + item.extensionId);
    }

    render() {
        const {courses} = this.props;
        let items = courses.data.map(item=>({
            extensionId: ''+item.id,
            name: item.title,
            rawURL: item.cover,
            //iconURL: ""
            //insetIconURL: ""
            featured: true,
            //description: item.desc,
        }));
        return (
            <Page isModal={true} title={window.L('teach.courses.manage')}>
                <div className={cn(styles.antLayoutContent, styles.sitedivContent, styles.pageContentMargin)}>
                    <div className={styles.antRow} style={{margin:"-8px -8px 8px"}}>
                        <div className={cn(styles.antCol, styles.antCol24)} style={{padding: "8px"}}>
                            <LibraryComponent
                                data={items}
                                filterable={false}
                                id="TeacherCoursesLibrary"
                                title="班级列表"
                                visible={true}
                                onItemSelected={this.handleItemSelect}
                            />
                        </div>
                    </div>
                </div>
                <Footer/>
            </Page>
        );
    }
}

const mapStateToProps = state => ({
    courses: state.teach.courses,
});


const mapDispatchToProps = dispatch => ({
    setCourses: courses => dispatch(setCourses(courses))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TeacherCoursesPage);
